export default {
  entityEditDialog: (state) => { return state.entityEditDialog },
};


// WEBPACK FOOTER //
// ./src/store/systemSetup/getters.js